/* src/app/shared/navbar/navbar.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@media screen and (min-width: 1001px) {
  header {
    display: block;
    position: fixed;
    width: 100%;
    z-index: 999;
    height: 70px;
  }
  .navbar-web {
    display: block;
  }
  .navbar-mobile {
    display: none;
  }
  .navbar-landing-container {
    display: flex;
    flex-direction: row;
    padding: 0px 30px;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.2);
    align-items: center;
    background-color: rgb(255, 255, 255);
  }
  .header-title {
    font-family: "Gotham-Bold", serif;
    font-size: 20px;
    color: #171C8F;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .navbar-icon {
    height: 68px;
    width: 424px;
  }
  .title-link:hover {
    text-decoration: none;
  }
  .links-container {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    height: 68px;
  }
  .navbar-link {
    color: #333333;
    margin: 0px 20px;
    padding: 15px 0px;
    height: 100%;
    font-family: "Calibri", serif;
    font-size: 18px;
    border-bottom: 4px solid rgba(255, 255, 255, 0);
    cursor: pointer;
    text-decoration: none;
  }
  .navbar-link:hover {
    text-decoration: none;
    color: #333333;
  }
  .active {
    color: #333333;
    font-weight: bold;
    border-bottom: 4px solid #F2D052;
  }
  .mobile-cover {
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  header {
    display: block;
    position: fixed;
    width: 100%;
    z-index: 999;
    height: 70px;
  }
  .navbar-web {
    display: none;
  }
  .navbar-mobile {
    display: block;
  }
  .navbar-landing-container {
    display: flex;
    flex-direction: row;
    padding: 0px 20px;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.2);
    align-items: center;
    background-color: rgb(255, 255, 255);
  }
  .navbar-icon {
    height: 40px;
  }
  .navbar-toggle {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .navbar-menus {
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.2);
    z-index: 998;
    display: flex;
    flex-direction: column;
  }
  .navbar-menus * {
    font-family: "Calibri", serif;
    font-size: 22px;
    padding: 22px 20px;
    color: #333333;
    border-bottom: 1px solid rgba(25, 34, 141, 0.1490196078);
    cursor: pointer;
  }
  .navbar-menus a:hover {
    text-decoration: none;
  }
  .navbar-menus a.active {
    font-weight: bold;
  }
  .mobile-cover {
    display: block;
    position: absolute;
    z-index: 998;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0);
  }
}
/*# sourceMappingURL=navbar.component.css.map */
